import api from "../services/api";
import {
  IVotingSession,
  IVotingSessionResponse,
  IVotingSessionSingleResponse,
  IVotesResponse,
  IVotingResultsResponse,
  ICanVoteResponse,
  ICreateVotingSessionRequest,
  IUpdateVotingSessionRequest,
  ICastVoteRequest,
  IAwardVote,
  IVotingResultsSummary,
} from "../models/IVoting";

// Voting Session Management
export const getVotingSessions = (): Promise<IVotingSessionResponse> => api.get("/voting/sessions");

export const getVotingSessionById = (id: string): Promise<IVotingSessionSingleResponse> =>
  api.get(`/voting/sessions/${id}`);

export const getVotingSessionsByTournament = (tournamentId: string): Promise<IVotingSessionResponse> =>
  api.get(`/voting/sessions/tournament/${tournamentId}`);

export const createVotingSession = (data: ICreateVotingSessionRequest): Promise<IVotingSessionSingleResponse> =>
  api.post("/voting/sessions", data);

export const updateVotingSession = (
  id: string,
  data: IUpdateVotingSessionRequest
): Promise<IVotingSessionSingleResponse> => api.put(`/voting/sessions/${id}`, data);

export const deleteVotingSession = (id: string): Promise<{ data: boolean; success: boolean }> =>
  api.delete(`/voting/sessions/${id}`);

// Voting Operations
export const castVote = (data: ICastVoteRequest): Promise<{ data: IAwardVote; success: boolean }> =>
  api.post("/voting/vote", data);

export const getVotingResults = (sessionId: string): Promise<IVotingResultsResponse> =>
  api.get(`/voting/sessions/${sessionId}/results`);

export const checkCanVote = (sessionId: string, awardId: string): Promise<ICanVoteResponse> =>
  api.get(`/voting/sessions/${sessionId}/can-vote/${awardId}`);
